import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  Table,
  Input,
  InputNumber,
  Popconfirm,
  Form,
  message,
  Checkbox,
  Tooltip,
  Icon,
  Button,
  Select,
  DatePicker,
} from 'antd';
import {
  LoaderContainer,
  CreateButton,
  TableContainer,
  CountTile,
  WarningLabel,
  SearchContainer,
  ReadableCommaDiv,
} from './styles';
import Loader from '../../components/Loader';
import { withTranslation } from 'react-i18next';
import { deleteVariable } from '../../utils/services/variablesAPI';
import { saveVariable, updateVariable } from '../../utils/services/variablesAPI';
import { MANAGE_ENTITY_DETAILS } from './translationValues';
import moment from 'moment';
import { VARIABLE_TYPE } from '../../utils/constants/appConstants';
import AddRelationships from './AddRelationship';

const EditableContext = React.createContext();
const { Option } = Select;
const NAMESPACES = ['MANAGE_ENTITY_DETAILS'];
const dateFormat = 'DD-MM-YYYY';
class EditableCell extends React.Component {
  getInput = () => {
    if (this.props.inputType === 'number') {
      return <InputNumber />;
    } else if (this.props.inputType === 'date') {
      return <DatePicker format={dateFormat} showTime={false} />;
    }
    return <Input maxLength={this.props.dataIndex === 'displayName' ? 50 : null} onKeyDown={(e) => {
                        if (e.key === ' ' && e.target.value.trim() === '') {
                          e.preventDefault();
                        }
                      }}/>;
  };

  renderCell = ({ getFieldDecorator }) => {
    const {
      t,
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      mandatory,
      dataType,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required: dataIndex!=='displayName' ? mandatory : false,
                  message: `${title +
                    ' ' +
                    t(
                      MANAGE_ENTITY_DETAILS.KEY_REQUIRED_ERROR_MESSAGE.key,
                      MANAGE_ENTITY_DETAILS.KEY_REQUIRED_ERROR_MESSAGE.value,
                    )}`,
                },
              ],
              initialValue:
                typeof record[dataIndex] === 'object'
                  ? null
                  : dataIndex === 'exampleValue' && dataType === 'Date'
                  ? moment(record[dataIndex], dateFormat)
                  : record[dataIndex],
            })(this.getInput())}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  render() {
    return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
  }
}
const translatedCell = withTranslation()(EditableCell);
class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      editingKey: '',
      isLoading: true,
      disableButton: false,
      isMandatoryChecked: false,
      checkLength: false,
      length: 0,
      relationsshipType: 'onetoone',
      selectedCategoryId: [],
      showRelationModal: false,
      isAddingRelation: false,
    };
  }

  getColumns() {
    const { t, form } = this.props;
    const { resetFields } = form;
    const columns = [
      {
        title: t(
          MANAGE_ENTITY_DETAILS.VARIABLE_NAME_COLUMN_HEADER.key,
          MANAGE_ENTITY_DETAILS.VARIABLE_NAME_COLUMN_HEADER.value,
        ),
        dataIndex: 'name',
        editable: true,
        ...this.getColumnSearchProps('name', t),
      },
      {
        title: t(
          MANAGE_ENTITY_DETAILS.VARIABLE_DATA_TYPE_COLUMN_HEADER.key,
          MANAGE_ENTITY_DETAILS.VARIABLE_DATA_TYPE_COLUMN_HEADER.value,
        ),
        dataIndex: 'type',
        render: (text, record) => {
          const { editingKey, multiValData } = this.state;
          var today = new Date();
          var dd = String(today.getDate()).padStart(2, '0');
          var mm = String(today.getMonth() + 1).padStart(2, '0');
          var yyyy = today.getFullYear();
          today = dd + '-' + mm + '-' + yyyy;
          return multiValData?.isList && editingKey === record.key ? (
            'String'
          ) : editingKey === record.key && !record.isSaved ? (
            <Select
              labelInValue
              defaultValue={{
                key:
                  record.type === 'Date' ? 'Date' : record.type === 'ListDate' ? 'Date' : 'String',
              }}
              style={{ width: 80 }}
              onChange={e => {
                this.setState({ dataType: e.key });
                resetFields && resetFields('exampleValue');
                record.exampleValue = e.key === VARIABLE_TYPE.DATE ? today : 'Sample Value';
                if (e.key === VARIABLE_TYPE.DATE) {
                  this.setState({ checkLength: false, length: null });
                } else {
                  this.setState({length: 20});
                }
              }}
            >
              <Option value="String">
                {t(
                  MANAGE_ENTITY_DETAILS.STRING_DATA_TYPE_DROPWDOWN_VALUE.key,
                  MANAGE_ENTITY_DETAILS.STRING_DATA_TYPE_DROPWDOWN_VALUE.value,
                )}
              </Option>
              <Option value="Date">
                {t(
                  MANAGE_ENTITY_DETAILS.DATE_DATA_TYPE_DROPWDOWN_VALUE.key,
                  MANAGE_ENTITY_DETAILS.DATE_DATA_TYPE_DROPWDOWN_VALUE.value,
                )}
              </Option>
            </Select>
          ) : (
            <p style={{ width: 80 }}>
              {record.type === 'String'
                ? t(
                    MANAGE_ENTITY_DETAILS.STRING_DATA_TYPE_DROPWDOWN_VALUE.key,
                    MANAGE_ENTITY_DETAILS.STRING_DATA_TYPE_DROPWDOWN_VALUE.value,
                  )
                : record.type === 'ListString'
                ? t(
                    MANAGE_ENTITY_DETAILS.STRING_DATA_TYPE_DROPWDOWN_VALUE.key,
                    MANAGE_ENTITY_DETAILS.STRING_DATA_TYPE_DROPWDOWN_VALUE.value,
                  )
                : t(
                    MANAGE_ENTITY_DETAILS.DATE_DATA_TYPE_DROPWDOWN_VALUE.key,
                    MANAGE_ENTITY_DETAILS.DATE_DATA_TYPE_DROPWDOWN_VALUE.value,
                  )}
            </p>
          );
        },
      },
      {
        title: t(
          MANAGE_ENTITY_DETAILS.VARIABLE_VALIDATIONS_COLUMN_HEADER.key,
          MANAGE_ENTITY_DETAILS.VARIABLE_VALIDATIONS_COLUMN_HEADER.value,
        ),
        dataIndex: 'validations',
        render: (text, record) => {
          const { isMandatoryChecked, checkLength, length, editingKey, dataType } = this.state;
          const isEditing = record.key !== editingKey;
          if (isEditing) {
            return (
              <ReadableCommaDiv style={{ display: 'inline' }}>
                {record.mandatory ? (
                  <div>
                    {t(
                      MANAGE_ENTITY_DETAILS.VARIABLE_MANDATORY_COLUMN_HEADER.key,
                      MANAGE_ENTITY_DETAILS.VARIABLE_MANDATORY_COLUMN_HEADER.value,
                    )}
                  </div>
                ) : null}
                {record.checkLength ? (
                  <div>
                    {`${t(
                      MANAGE_ENTITY_DETAILS.VARIABLE_MAX_CHARACTERS_COLUMN_HEADER.key,
                      MANAGE_ENTITY_DETAILS.VARIABLE_MAX_CHARACTERS_COLUMN_HEADER.value,
                    )}: `}
                    {record.length}
                  </div>
                ) : null}
                {!record.mandatory && !record.checkLength
                  ? t(
                      MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUE_NOT_APPLICABLE.key,
                      MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUE_NOT_APPLICABLE.value,
                    )
                  : null}
              </ReadableCommaDiv>
            );
          }
          const values = [];

          if (isMandatoryChecked) {
            values.push('mandatory');
          }
          if (checkLength) {
            values.push('checkLength');
          }
          const handleChange = value => {
            const obj = { isMandatoryChecked: false, checkLength: false };
            if (value.includes('mandatory')) {
              obj.isMandatoryChecked = true;
            }
            if (value.includes('checkLength')) {
              obj.checkLength = true;
            } else {
              if (dataType === VARIABLE_TYPE.DATE) {
                obj.length = null;
              }
            }
            this.setState(obj);
          };
          return (
            <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
              <Select
                mode="multiple"
                style={{ width: '100%', maxWidth: '300px' }}
                placeholder={t(
                  MANAGE_ENTITY_DETAILS.VARIABLE_VALIDATIONS_PALCEHOLDER.key,
                  MANAGE_ENTITY_DETAILS.VARIABLE_VALIDATIONS_PALCEHOLDER.value,
                )}
                onChange={handleChange}
                value={values}
                allowClear
              >
                <Option key={'mandatory'}>
                  {t(
                    MANAGE_ENTITY_DETAILS.VARIABLE_MANDATORY_COLUMN_HEADER.key,
                    MANAGE_ENTITY_DETAILS.VARIABLE_MANDATORY_COLUMN_HEADER.value,
                  )}
                </Option>
                {dataType === VARIABLE_TYPE.STRING_TITLE_CASE ? (
                  <Option key={'checkLength'}>
                    {t(
                      MANAGE_ENTITY_DETAILS.VALIDATE_MAX_CHARACTERS_LABEL.key,
                      MANAGE_ENTITY_DETAILS.VALIDATE_MAX_CHARACTERS_LABEL.value,
                    )}
                  </Option>
                ) : null}
              </Select>

              {checkLength ? (
                <div style={{ display: 'flex', columnGap: '10px', alignItems: 'center' }}>
                  <label>{`${t(
                    MANAGE_ENTITY_DETAILS.VARIABLE_MAX_CHARACTERS_COLUMN_HEADER.key,
                    MANAGE_ENTITY_DETAILS.VARIABLE_MAX_CHARACTERS_COLUMN_HEADER.value,
                  )}: `}</label>
                  <InputNumber
                    value={length}
                    min={1}
                    onChange={value => this.setState({ length: value })}
                  />
                </div>
              ) : null}
            </div>
          );
        },
        width: '25%',
      },
      {
        title: t(
          MANAGE_ENTITY_DETAILS.VARIABLE_SAMPLE_VALUE_TABLE_HEADER.key,
          MANAGE_ENTITY_DETAILS.VARIABLE_SAMPLE_VALUE_TABLE_HEADER.value,
        ),
        dataIndex: 'exampleValue',
        editable: true,
        render(text, record) {
          return {
            props: {
              style: { wordBreak: 'break-word' },
            },
            children: (
              <div>
                {record.type === 'Date' && moment.isMoment(text) ? text.format(dateFormat) : text}
              </div>
            ),
          };
        },
      },
      {
        title: t(
          MANAGE_ENTITY_DETAILS.DISPLAY_NAME.key,
          MANAGE_ENTITY_DETAILS.DISPLAY_NAME.value,
        ),
        dataIndex: 'displayName',
        editable: true,
        render(text, record) {
          return {
            props: {
              style: { wordBreak: 'break-word' },
            },
            children: (
              <div>
                {text || t(
                MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUE_NOT_APPLICABLE.key,
                MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUE_NOT_APPLICABLE.value,
              )}
              </div>
            ),
          };
        },
      },
      {
        title: (
          <CountTile>
            <h5>
              {t(
                MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUES_COLUMN_HEADER.key,
                MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUES_COLUMN_HEADER.value,
              )}
            </h5>{' '}
            <p>
              {t(
                MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUES_DESC_COLUMN_HEADER.key,
                MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUES_DESC_COLUMN_HEADER.value,
              )}
            </p>
          </CountTile>
        ),
        dataIndex: 'type',
        // width: '16%',
        render: (text, record) => {
          const { editingKey, multiValData, warningText, dataType } = this.state;
          if (editingKey !== record.key) {
            return record.type === 'ListString' || record.type === 'ListDate'
              ? record.count
              : t(
                  MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUE_NOT_APPLICABLE.key,
                  MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUE_NOT_APPLICABLE.value,
                );
          }
          if (dataType === 'Date') {
            return t(
              MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUE_NOT_APPLICABLE.key,
              MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_VALUE_NOT_APPLICABLE.value,
            );
          }
          return (
            <>
              <div
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}
              >
                <Tooltip
                  placement="top"
                  title={
                    multiValData.isList
                      ? t(
                          MANAGE_ENTITY_DETAILS.REMOVE_FROM_MULTI_VARIABLE_TOOLTIP.key,
                          MANAGE_ENTITY_DETAILS.REMOVE_FROM_MULTI_VARIABLE_TOOLTIP.value,
                        )
                      : t(
                          MANAGE_ENTITY_DETAILS.CHANGE_TO_MULTI_VARIABLE_TOOLTIP.key,
                          MANAGE_ENTITY_DETAILS.CHANGE_TO_MULTI_VARIABLE_TOOLTIP.value,
                        )
                  }
                >
                  <Checkbox
                    checked={multiValData.isList}
                    onChange={e => {
                      multiValData.isList = e.target.checked;
                      this.setState({
                        multiValData: { ...multiValData },
                        dataType: 'String',
                      });
                    }}
                  />
                </Tooltip>
                {multiValData.isList && (
                  <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                    <Input
                      placeholder={t(
                        MANAGE_ENTITY_DETAILS.MAXIMUM_LINES_PLACEHOLDER.key,
                        MANAGE_ENTITY_DETAILS.MAXIMUM_LINES_PLACEHOLDER.value,
                      )}
                      value={editingKey !== record.key ? record.count : multiValData?.count}
                      onChange={e => {
                        multiValData.count = e.target.value;
                        this.setState({
                          multiValData: { ...multiValData },
                          warningText: multiValData.count
                            ? ''
                            : t(
                                MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_LINE_EMPTY_ERROR_MESSAGE.key,
                                MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_LINE_EMPTY_ERROR_MESSAGE
                                  .value,
                              ),
                        });
                      }}
                      style={{
                        border: warningText && ' 1px solid #f5222d',
                        boxShadow: warningText && 'none',
                      }}
                    />
                    <WarningLabel>{warningText}</WarningLabel>
                  </div>
                )}
              </div>
            </>
          );
        },
      },
      {
        title: t(
          MANAGE_ENTITY_DETAILS.VARIABLE_ACTIONS_COLUMN_HEADER.key,
          MANAGE_ENTITY_DETAILS.VARIABLE_ACTIONS_COLUMN_HEADER.value,
        ),
        dataIndex: 'operation',
        render: (text, record) => {
          const { editingKey } = this.state;
          const editable = this.isEditing(record);
          if (record.usedCount > 0) {
            return (
              <span>
                {t(
                  MANAGE_ENTITY_DETAILS.VARIABLE_NOT_EDITABLE_ERROR_MESSAGE.key,
                  MANAGE_ENTITY_DETAILS.VARIABLE_NOT_EDITABLE_ERROR_MESSAGE.value,
                )}
              </span>
            );
          } else {
            return (
              <>
                {editable ? (
                  <span>
                    {record.isSaved ? (
                      <EditableContext.Consumer>
                        {form => (
                          <Popconfirm
                            title={t(
                              MANAGE_ENTITY_DETAILS.UPDATE_VARIABLE_TITLE_CONFIRMATION_POPUP.key,
                              MANAGE_ENTITY_DETAILS.UPDATE_VARIABLE_TITLE_CONFIRMATION_POPUP.value,
                            )}
                            onConfirm={() => this.handleSave(form, record.key, 'update')}
                            cancelText={t(
                              MANAGE_ENTITY_DETAILS.CANCEL_LABEL.key,
                              MANAGE_ENTITY_DETAILS.CANCEL_LABEL.value,
                            )}
                            okText={t(
                              MANAGE_ENTITY_DETAILS.OK_LABEL.key,
                              MANAGE_ENTITY_DETAILS.OK_LABEL.value,
                            )}
                          >
                            <span className="varActions" style={{ marginRight: 8 }}>
                              {t(
                                MANAGE_ENTITY_DETAILS.UPDATE_VARIABLE_ACTION_BUTTON.key,
                                MANAGE_ENTITY_DETAILS.UPDATE_VARIABLE_ACTION_BUTTON.value,
                              )}
                            </span>
                          </Popconfirm>
                        )}
                      </EditableContext.Consumer>
                    ) : (
                      <EditableContext.Consumer>
                        {form => (
                          <Popconfirm
                            title={t(
                              MANAGE_ENTITY_DETAILS.SAVE_VARIABLE_TITLE_CONFIRMATION_POPUP.key,
                              MANAGE_ENTITY_DETAILS.SAVE_VARIABLE_TITLE_CONFIRMATION_POPUP.value,
                            )}
                            onConfirm={() => this.handleSave(form, record.key, 'save')}
                            cancelText={t(
                              MANAGE_ENTITY_DETAILS.CANCEL_LABEL.key,
                              MANAGE_ENTITY_DETAILS.CANCEL_LABEL.value,
                            )}
                            okText={t(
                              MANAGE_ENTITY_DETAILS.OK_LABEL.key,
                              MANAGE_ENTITY_DETAILS.OK_LABEL.value,
                            )}
                          >
                            <span className="varActions" style={{ marginRight: 8 }}>
                              {t(
                                MANAGE_ENTITY_DETAILS.SAVE_VARIABLE_ACTION_BUTTON.key,
                                MANAGE_ENTITY_DETAILS.SAVE_VARIABLE_ACTION_BUTTON.value,
                              )}
                            </span>
                          </Popconfirm>
                        )}
                      </EditableContext.Consumer>
                    )}
                    {record.isSaved && (
                      <span
                        className="varActions"
                        style={{ marginRight: 8, lineHeight: '24px' }}
                        onClick={() => this.cancel(record.key, record)}
                      >
                        {t(
                          MANAGE_ENTITY_DETAILS.CANCEL_VARIABLE_ACTION_BUTTON.key,
                          MANAGE_ENTITY_DETAILS.CANCEL_VARIABLE_ACTION_BUTTON.value,
                        )}
                      </span>
                    )}
                  </span>
                ) : (
                  editingKey === '' && (
                    <span
                      className="varActions"
                      // disabled={editingKey !== ''}
                      style={{ marginRight: 8 }}
                      onClick={() => this.edit(record.key)}
                    >
                      {t(
                        MANAGE_ENTITY_DETAILS.EDIT_VARIABLE_ACTION_BUTTON.key,
                        MANAGE_ENTITY_DETAILS.EDIT_VARIABLE_ACTION_BUTTON.value,
                      )}
                    </span>
                  )
                )}
                {this.state.disableButton && record.isSaved ? (
                  <span className="varActions" style={{ marginRight: 8, cursor: 'not-allowed' }}>
                    {t(
                      MANAGE_ENTITY_DETAILS.DELETE_VARIABLE_ACTION_BUTTON.key,
                      MANAGE_ENTITY_DETAILS.DELETE_VARIABLE_ACTION_BUTTON.value,
                    )}
                  </span>
                ) : (
                  <Popconfirm
                    title={t(
                      MANAGE_ENTITY_DETAILS.DELETE_VARIABLE_TITLE_CONFIRMATION_POPUP.key,
                      MANAGE_ENTITY_DETAILS.DELETE_VARIABLE_TITLE_CONFIRMATION_POPUP.value,
                    )}
                    onConfirm={() => this.handleDelete(record.key, record)}
                    cancelText={t(
                      MANAGE_ENTITY_DETAILS.CANCEL_LABEL.key,
                      MANAGE_ENTITY_DETAILS.CANCEL_LABEL.value,
                    )}
                    okText={t(
                      MANAGE_ENTITY_DETAILS.OK_LABEL.key,
                      MANAGE_ENTITY_DETAILS.OK_LABEL.value,
                    )}
                  >
                    <span className="varActions" style={{ marginRight: 8 }}>
                      {t(
                        MANAGE_ENTITY_DETAILS.DELETE_VARIABLE_ACTION_BUTTON.key,
                        MANAGE_ENTITY_DETAILS.DELETE_VARIABLE_ACTION_BUTTON.value,
                      )}
                    </span>
                  </Popconfirm>
                )}
              </>
            );
          }
        },
      },
    ];
    return columns;
  }

  componentDidMount() {
    const { tableData, categoryId } = this.props;
    let dataList = [];
    tableData &&
      tableData.forEach((element, index) => {
        if (element.variableCategoryId === categoryId) {
          let data = {
            key: element.id,
            name: element.name,
            length: element.length,
            exampleValue: element.exampleValue,
            displayName: element.displayName,
            usedCount: element.variableRefData?.usedCount,
            isSaved: true,
            type: element.type,
            count: element.count,
            mandatory: element.mandatory,
            checkLength: element.checkLength
          };
          dataList.push(data);
        }
      });
    this.setState({
      isLoading: false,
      data: dataList,
      currentPage: 1,
      warningText: '',
    });
  }

  getColumnSearchProps = (dataIndex, t) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <SearchContainer style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          // placeholder={`Search ${dataIndex}`}
          placeholder={t(
            MANAGE_ENTITY_DETAILS.VARIABLE_NAME_SEARCH_PLACEHOLDER.key,
            MANAGE_ENTITY_DETAILS.VARIABLE_NAME_SEARCH_PLACEHOLDER.value,
            { dataIndex: dataIndex },
          )}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          {t(
            MANAGE_ENTITY_DETAILS.VARIABLE_SEARCH_CONFIRMATION_BUTTON.key,
            MANAGE_ENTITY_DETAILS.VARIABLE_SEARCH_CONFIRMATION_BUTTON.value,
          )}
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          {t(
            MANAGE_ENTITY_DETAILS.VARIABLE_SEARCH_CLEAR_CONFIRMATION_BUTTON.key,
            MANAGE_ENTITY_DETAILS.VARIABLE_SEARCH_CLEAR_CONFIRMATION_BUTTON.value,
          )}
        </Button>
      </SearchContainer>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  isEditing = record => record.key === this.state.editingKey;

  cancel = (key, record) => {
    const dataSource = [...this.state.data];
    let prevData = this.props.tableData.filter(item => item.id === key);
    dataSource.forEach(data => {
      if (data.key === key && prevData.length > 0) {
        data.exampleValue = prevData[0].exampleValue;
      }
    });
    if (!record.isSaved) {
      this.setState({ data: dataSource.filter(item => item.key !== key) });
    }
    this.setState({
      editingKey: '',
      multiValData: { isList: record.isList, count: record.count },
      warningText: '',
      isMandatoryChecked: false,
      checkLength: false,
      length: 0,
    });
  };

  validateInput = (record, multiValVar) => {
    const { t } = this.props;
    //eslint-disable-next-line
    let format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~\s]/;
    if (format.test(record.name)) {
      message.error(
        t(
          MANAGE_ENTITY_DETAILS.VARIABLE_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE.key,
          MANAGE_ENTITY_DETAILS.VARIABLE_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE.value,
        ),
      );
      return true;
    }
    else {
      return false;
    }
  };

  handleDelete = async (key, record) => {
    const dataSource = [...this.state.data];
    const payload = {
      id: key,
    };
    if (record.isSaved) {
      let deletionResponse = await deleteVariable(payload);
      if (deletionResponse && deletionResponse.errors && deletionResponse.errors.length === 0) {
        this.setState({ data: dataSource.filter(item => item.key !== key) });
      }
    } else {
      this.setState({ data: dataSource.filter(item => item.key !== key) });
    }
    this.setState({ editingKey: '', disableButton: false });
  };

  handleSave(form, key, action) {
    const { t } = this.props;
    form.validateFields(async (error, row) => {
      const { multiValData, data, dataType, isMandatoryChecked, length, checkLength } = this.state;
      if (error) {
        return;
      }
      let isNotValidInput = this.validateInput(row, false);
      if (isNotValidInput) {
        return;
      }
      let payload = {
        exampleValue: moment.isMoment(row.exampleValue)
          ? row.exampleValue.format(dateFormat)
          : row.exampleValue.trim(),
        placeHolderText: `${this.props.categoryName}.${row.name}`,
        variableCategoryId: this.props.categoryId,
        length: length,
        name: row.name,
        type:
          dataType === 'Date'
            ? multiValData.isList
              ? 'ListDate'
              : 'Date'
            : multiValData.isList
            ? 'ListString'
            : 'String',
        count: multiValData.isList ? multiValData.count : undefined,
        mandatory: isMandatoryChecked,
        checkLength: checkLength,
        displayName: row.displayName?.trim()
      };
      const newData = [...data];

      let isWarning;
      if (multiValData.isList) {
        this.setState({
          warningText: multiValData.count
            ? ''
            : t(
                MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_LINE_EMPTY_ERROR_MESSAGE.key,
                MANAGE_ENTITY_DETAILS.VARIABLE_MAXIMUM_LINE_EMPTY_ERROR_MESSAGE.value,
              ),
        });
      }
      isWarning = multiValData.isList
        ? multiValData.count
          ? this.validateInput(multiValData.count, true)
          : true
        : multiValData.isList;

      if (!isWarning) {
        if (action === 'save') {
          let response = await saveVariable(payload);
          this.setState({
            disableButton: false,
          });
          if (response && response.errors && response.errors.length === 0) {
            row.isSaved = true;
            row.key = response.id;
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
              const item = newData[index];
              newData.splice(index, 1, {
                ...item,
                ...row,
                count: multiValData.isList ? parseInt(multiValData.count) : undefined,
                type:
                  dataType === 'Date'
                    ? multiValData.isList
                      ? 'ListDate'
                      : 'Date'
                    : multiValData.isList
                    ? 'ListString'
                    : 'String',
                mandatory: isMandatoryChecked,
                length: length,
                checkLength: checkLength,
              });
              this.setState({ data: newData, editingKey: '' });
            } else {
              newData.push(row);
              this.setState({ data: newData, editingKey: '' });
            }
          } else {
            this.setState({ data: newData.filter(item => item.key !== key), editingKey: '' });
          }
        } else {
          payload.id = key;
          let updateResponse = await updateVariable(payload);
          if (updateResponse && updateResponse.errors && updateResponse.errors.length === 0) {
            let updateData = data.map(item => {
              const updatedItem = { ...item };
              if (item.key === key) {
                updatedItem.count = multiValData.isList ? parseInt(multiValData.count) : undefined;
                updatedItem.type =
                  dataType === 'Date'
                    ? multiValData.isList
                      ? 'ListDate'
                      : 'Date'
                    : multiValData.isList
                    ? 'ListString'
                    : 'String';
                updatedItem.mandatory = isMandatoryChecked;
                updatedItem.length = length;
                updatedItem.checkLength = checkLength;
              }
              return updatedItem;
            });
            this.setState({
              data: updateData,
            });
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
              const item = newData[index];
              newData.splice(index, 1, {
                ...item,
                ...row,
                mandatory: isMandatoryChecked,
                length: length,
                checkLength: checkLength,
              });
              this.setState({ data: newData, editingKey: '' });
            } else {
              newData.push(row);
              this.setState({ data: newData, editingKey: '' });
            }
          } else {
            this.setState({ editingKey: '' });
          }
        }
      }
    });
  }

  edit(key) {
    let newData = this.state.data.filter(item => item.key === key);
    this.setState({
      editingKey: key,
      multiValData: { count: newData[0].count, isList: newData[0].type.includes('List') },
      dataType: newData[0].type,
      isMandatoryChecked: newData[0].mandatory,
      checkLength: newData[0].checkLength,
      length: newData[0].length,
    });
  }

  handleAdd = () => {
    const { t } = this.props;
    const newData = {
      key: uuidv4(),
      name: (
        <Input
          placeholder={t(
            MANAGE_ENTITY_DETAILS.VARIABLE_NAME_PLACEHOLDER.key,
            MANAGE_ENTITY_DETAILS.VARIABLE_NAME_PLACEHOLDER.value,
          )}
          disabled={true}
        />
      ),
      length: (
        <Input
          placeholder={t(
            MANAGE_ENTITY_DETAILS.VARIABLE_LENGTH_PLACEHOLDER.key,
            MANAGE_ENTITY_DETAILS.VARIABLE_LENGTH_PLACEHOLDER.value,
          )}
          disabled={true}
        />
      ),
      exampleValue: (
        <Input
          placeholder={t(
            MANAGE_ENTITY_DETAILS.VARIABLE_SAMPLE_VALUE_PLACEHOLDER.key,
            MANAGE_ENTITY_DETAILS.VARIABLE_SAMPLE_VALUE_PLACEHOLDER.value,
          )}
          disabled={true}
        />
      ),
      usedCount: 0,
      isSaved: false,
      isDisable: true,
      mandatory: false,
    };

    this.setState({
      data: [newData, ...this.state.data],
      dataType: 'String',
      currentPage: 1,
      editingKey: newData.key,
      multiValData: {},
      disableButton: true,
      isMandatoryChecked: false,
      checkLength: false,
      length: 20,
    });
  };

  render() {
    const { t } = this.props;
    const updatedColumns = this.getColumns();
    const components = {
      body: {
        cell: translatedCell,
      },
    };
    const currentCategoryName = this.props.allCategory.find(el => el.id === this.props.categoryId)?.name || '';
    const columns = updatedColumns.map(col => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType:
            col.dataIndex === 'age' || col.dataIndex === 'length'
              ? 'number'
              : col.dataIndex === 'exampleValue' && this.state.dataType === 'Date'
              ? 'date'
              : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing:
            this.isEditing(record) &&
            !(col.dataIndex === 'length' && this.state.dataType === 'Date'),
          mandatory: col.dataIndex !== 'length',
          dataType: this.state.dataType,
          displayName: col.displayName
        }),
      };
    });

    return (
      <EditableContext.Provider value={this.props.form}>
        <TableContainer>
          {this.state.isLoading ? (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          ) : (
            <>
              <CreateButton
                onClick={this.handleAdd}
                type="primary"
                style={{ marginBottom: 20 }}
                size="default"
                disabled={this.state.disableButton}
              >
                {t(
                  MANAGE_ENTITY_DETAILS.ADD_VARIABLE_BUTTON.key,
                  MANAGE_ENTITY_DETAILS.ADD_VARIABLE_BUTTON.value,
                )}
              </CreateButton>
              <Table
                components={components}
                bordered
                dataSource={this.state.data}
                columns={columns}
                rowClassName="editable-row"
                pagination={{
                  current: this.state.currentPage,
                  onChange: e => this.setState({ currentPage: e }),
                  defaultPageSize: 5,
                  hideOnSinglePage: true,
                }}
              />
              <AddRelationships t={t} sourceCategoryId={this.props.categoryId} currentCategoryName={currentCategoryName} allCategories={this.props.allCategoryList} />
            </>
          )}
        </TableContainer>
      </EditableContext.Provider>
    );
  }
}

const VariableTable = Form.create()(EditableTable);
export default withTranslation(NAMESPACES)(VariableTable);
